// extracted by mini-css-extract-plugin
export default {"editor":"CodeEditor_editor__onyM1"};